// extracted by mini-css-extract-plugin
module.exports = {"sidebarContainer":"sidebar-module--sidebarContainer--87swF","sidebarHeading":"sidebar-module--sidebarHeading--XcnCD"};